/**
 * Componente para almacenar el contexto de autenticación del usuario. Esto permite que los
 * distintos componentes reciban la información de autenticación y poder actualizar los cambios
 * que se produzcan en la sesión del usuario.
**/

import { createContext, useContext, useEffect, useState } from "react";
import { auth, onAuthStateChanged } from "./FirebaseConfig";

//Se crea el contexto con el que hacer seguimiento del estado del usuario
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  /*********************************** VARIABLES DE COMPONENTE ***********************************/
  /***********************************************************************************************/
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  /***********************************************************************************************/
  /***********************************************************************************************/

  /*********************************** FUNCIONES DE COMPONENTE ***********************************/
  /***********************************************************************************************/
  //Gestiona cuando se produce un cambio en el usuario autenticado y almacena el nuevo usuario
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  /***********************************************************************************************/
  /***********************************************************************************************/

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);